import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Blogs.css';

const API = 'http://localhost:5000/api';

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/blogs`)
      .then(r => { setBlogs(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [blogs]);

  const filtered = blogs.filter(b =>
    b.title.toLowerCase().includes(search.toLowerCase()) ||
    (b.category || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="blogs-page">
      <section className="blogs-hero">
        <div className="container">
          <span className="section-label reveal">ब्लॉग</span>
          <h1 className="reveal">स्वास्थ्य जानकारी एवं लेख</h1>
          <p className="reveal">महिला स्वास्थ्य, आयुर्वेद और प्राकृतिक उपचार से जुड़ी उपयोगी जानकारी</p>
          <div className="blogs-search reveal">
            <input type="text" placeholder="ब्लॉग खोजें..." value={search} onChange={e => setSearch(e.target.value)} />
            <span className="search-icon">🔍</span>
          </div>
        </div>
      </section>

      <section className="blogs-content">
        <div className="container">
          {loading ? (
            <div className="blogs-loading">
              {[1,2,3].map(i => <div className="blog-skeleton" key={i} />)}
            </div>
          ) : filtered.length === 0 ? (
            <div className="blogs-empty">
              <div className="empty-icon">📝</div>
              <h3>कोई ब्लॉग नहीं मिला</h3>
              <p>{search ? 'अपनी खोज बदलें' : 'जल्द ही नए ब्लॉग आएंगे'}</p>
            </div>
          ) : (
            <div className="blogs-grid-full">
              {filtered.map((b, i) => (
                <Link to={`/blogs/${b.slug}`} className="blog-card reveal" key={b.id} style={{ animationDelay: `${i * 0.08}s` }}>
                  <div className="blog-card-img">
                    {b.image_url
                      ? <img src={`http://localhost:5000${b.image_url}`} alt={b.title} />
                      : <div className="blog-img-placeholder">📰</div>
                    }
                  </div>
                  <div className="blog-card-body">
                    <div className="blog-card-meta">
                      <span className="blog-category">{b.category}</span>
                      <span className="blog-date">{new Date(b.created_at).toLocaleDateString('hi-IN')}</span>
                    </div>
                    <h2>{b.title}</h2>
                    <p>{b.excerpt}</p>
                    <div className="blog-card-footer">
                      <span className="blog-author">✍️ {b.author}</span>
                      <span className="blog-cta">पढ़ें →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}